import React, {Component} from 'react'
import {Message, Popup, Icon} from 'semantic-ui-react'
import ConfirmationPage from '../../ConfirmationPage'

class SuccessMessage extends Component
{
  constructor(props)
  {
    super(props)
    this.state = { hidden: false, percentById: {}}
  }

  onPercent = (id, percent) => {
    this.setState({ percentById: { ...this.state.percentById, [id]: percent } })
  }

  onRefClick = (e, x) => {
    if ((this.state.percentById[x] || 0) < 100) {
      e.preventDefault()
      alert('Please wait until complete')
    }
  }

  render() {
    const {successId} = this.props
    if (this.state.hidden) return null

    return (
      <React.Fragment>
        <Message onDismiss={() => this.setState({ hidden: true })} style={{marginBottom: '75px', paddingBottom: '50px'}}>
          <h1><Icon name="check circle" style={{color: 'green'}}/> Order uploaded successfully</h1>
          {successId.split(',').map((x, i) => {
            return (
              ['D', 'A', 'P'].includes(x[0]) ? <ConfirmationPage id={x} onPercent={this.onPercent}/> : null
            )
          })}

        </Message>

        <div style={{position: 'relative', bottom: '17px', borderBottom: '1px solid rgb(201,201,201)'}}/>
      </React.Fragment>
    )
  }
}

export default SuccessMessage
